
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Contents",
      function () {
        return require("private-next-pages/Contents.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Contents"])
      });
    }
  